<div class="d-block w-100 col-top">
  <div id="widget_pool_recommended" (click)="openLink()" [ngClass]="{'clickable': clickable}">
    <img alt="widget" class="widget-image" [src]="bannerImage" imgLazyLoad />
  </div>
</div>
